class BillingController {
  constructor(paymentService, ccTypeMap) {
    this.loading = false;
    this.paymentService = paymentService;
    this.ccTypeMap = ccTypeMap;
    this.isANumber = (val) => {
      return !Number.isNaN(val);
    };

    this.orEmpty = (entity) => {
      return entity || '';
    };

    this.showDate = (str) => {
      let newDate = '';
      if (this.isANumber(str.month) && this.isANumber(str.year)) {
        newDate = `${this.orEmpty(str.month)}/${this.orEmpty(str.year)}`;
        return newDate;
      }
      return false;
    };
  }

  $postLink() {
    this.loading = true;

    return this.paymentService.getPayment(this.paymentId)
      .then((payment) => {
        this.payment = payment;

        return payment;
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
angular.module('msi.payments')
  .controller('BillingController', BillingController);

BillingController.$inject = ['paymentService', 'ccTypeMap'];

module.exports = BillingController;
